import IMG_SETUP_PROCESS from 'assets/images/stripe/setup-stripe-process.png';
import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './StripeSetupNoticeModal.module.scss';

const StripeSetupNoticeModal = ({ isOpen, onClick, onClose }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="StripeSetupNoticeModal-modal" isOpen={isOpen} withFooter>
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.image}>
          <IconStatus variant="alert">
            <Icon variant="alert" />
          </IconStatus>
        </div>
        <div className={CN.modalContent}>
          <span className={CN.bold}>{t('onlineBooking.generalSettings.stripeSetupModal.title')}</span>
          <img src={IMG_SETUP_PROCESS} alt="NOT change the type of business screenshot" className={CN.modalImg} />
          <span className={CN.bold}>{t('onlineBooking.generalSettings.stripeSetupModal.description1Part1')}</span> {t('onlineBooking.generalSettings.stripeSetupModal.description1Part2')}
          <p>
            <span className={CN.bold}>{t('onlineBooking.generalSettings.stripeSetupModal.description2Part1')}</span> {t('onlineBooking.generalSettings.stripeSetupModal.description2Part2')}
          </p>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="primaryForce" onClick={onClick}>
          <span className={CN.buttonSpace}>{t('onlineBooking.generalSettings.stripeSetupModal.confirmButton')}</span>
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default StripeSetupNoticeModal;
